

export const modalPaperProps = { sx: { borderRadius: '0px', maxWidth: '95vw', maxHeight: '95vh' } };
